import { useCallback } from "react";
import { CamerasWrapperRoot } from "./CamerasWrapper.styles";
import { OptionGroup } from "../OptionGroup";
import { useSelectedOptions } from "../../context/SelectedOptionsContext";
import { optionsList } from "../../app/actions-list";

export const CamerasWrapper = ({ emitUIInteraction }) => {
  const {
    selectOption,
    map: selectedMap, // single source of truth (hydrated + persisted)
  } = useSelectedOptions();

  const cameras = optionsList?.cameras?.subActions;

  const clickOnAction = useCallback(
    (descriptor) => {
      if (typeof emitUIInteraction === "function") {
        emitUIInteraction(descriptor);
      } else {
        console.warn("emitUIInteraction is not ready yet", emitUIInteraction);
      }
    },
    [emitUIInteraction]
  );

  return (
    <CamerasWrapperRoot>
      <OptionGroup
        items={cameras}
        clickOnAction={clickOnAction}
        onSelectOption={(payload) => selectOption(payload)}
        selectedMap={selectedMap}
        cameras={true}
      />
    </CamerasWrapperRoot>
  );
};
